/**
 * Created by asiulik on 21.02.2018.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter'], function($, _, EventEmitter){

    var timeout;
    function FinderFilter($finder){ this.$finder = $finder; }

    FinderFilter.prototype = _.clone(EventEmitter.prototype);

    FinderFilter.prototype.init = function(){

        this.$finderInput = this.$finder.find('[data-finder-map]');
        this.$selectFilter = this.$finder.find('[data-finder-select-filter]');

        if(!this.$finderInput.length) return;

        this.bindEvents();

    };

    FinderFilter.prototype.bindEvents = function(){

        var _this = this;

        this.$finderInput.on('change', function(event){

            if(timeout) clearTimeout(timeout);

            timeout = setTimeout(function(){

                var value = event.currentTarget.value;
                _this.emit('finder:filter:change', value, { queryParamName: "postcode" });

            }, 400)


        });

        this.$selectFilter.on('change', function(event){

            if(timeout) clearTimeout(timeout);

            timeout = setTimeout(function(){

                var value = event.currentTarget.value;
                _this.emit('finder:filter:change', value, { queryParamName: "country" });

            }, 400)


        });

        this.emit('finder:filter:set', this.$selectFilter.val(), { queryParamName: "country" });

    };

    FinderFilter.prototype.getSelectedValues = function(){

        return {
            code: this.$finderInput.val(),
            country: this.$selectFilter.val()
        }

    };

    return FinderFilter;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/finder/finderFilters.js